export * from './transfer-types';
export const TRIPLE_CLICK = 3;
